import React from 'react';
import { IIconProps } from './utils';

export const CollapseRounded = ({
  fill = 'currentColor', height = null, width = null, ...rest
}: IIconProps) => (
  <svg fill="none" height={height} viewBox="0 0 30 30" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M25.5 4L18 11.5M18 11.5V5.25M18 11.5H24.25"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
    <path
      d="M4 25.5L11.5 18M11.5 18V24.25M11.5 18H5.25"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </svg>
);
